/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcProspectusV1ProspectusTaskEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PROSPECTUS_V1_PROSPECTUS_TASK_EVENT_ENTITY_NAME = 'ixc.prospectus.v1.ProspectusTaskEvent';
export const ixcProspectusV1ProspectusTaskEventEntity = new schema.Entity<IxcProspectusV1ProspectusTaskEvent>(IXC_PROSPECTUS_V1_PROSPECTUS_TASK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcProspectusV1ProspectusTaskEvent) => `${entity.metadata?.eventId}` });

